import React, { useEffect, useState, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import tu_logo_aqui from "../../img/logos/tu_logo_aqui.png";
import { fetchMenus } from "../../services/firebase/menus/index";
import styled, { css } from "styled-components";
const MenuLateralWrapper = styled.div`
  width: 100%;
  color: #5a5a5a;
  font-size: 14px;
`;

const Navbar = styled.div`
  display: flex;
  
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #fff;
  width: 250px;
  height: 100vh;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  border-right: 1px solid #e0e0e0;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  z-index: 1200;
  position: fixed;
  top: 0;
  left: 0;

  ${({ isMobile }) => isMobile && css`
    transform: translateX(-100%);
    &.is-open {
      transform: translateX(0);
    }
  `}

  ${({ isOpen, isMobile }) => !isMobile && css`
    transform: ${isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  `}
`;

const Backdrop = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1100; /* Below the menu */
  }
`;

const SubItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
`;

const DivItemMenu = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 0px;
  border-bottom: 1px solid #e0e0e0;
`;

const DivTitle = styled.div`
  width: 100%;
  padding: 0px 20px;
`;

const SpanTitleMenu = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  i {
    margin-right: 10px;
    font-size: 20px;
    color: #0c8de3;
  }
`;

const DivSubItem = styled.div`
  width: 100%;
  background-color: #f7f7f7;
  &.sub-item-menu-hidden {
    display: none;
  }
  &.sub-item-menu-visible {
    display: block;
  }
`;

const DivSubTitleMenu = styled.div`
  padding: 5px 20px;
`;

const DivSubtitlte = styled.div`
  .subtitle-menu {
    text-decoration: none;
    color: #5a5a5a;
    &:hover {
      color: #0c8de3;
    }
    &.active {
      color: #0c8de3;
      font-weight: 500;
    }
  }
`;

const SpanSubTitleMenu = styled.span`
  display: flex;
  align-items: center;
  padding: 5px 0px;
  i {
    margin-right: 10px;
    font-size: 16px;
  }
`;

const DivSubTitleMenuItem = styled.div`
  padding-left: 25px;
  .subtitle-menu-item {
    text-decoration: none;
    color: #5a5a5a;
    &:hover {
      color: #0c8de3;
    }
    &.active {
      color: #0c8de3;
      font-weight: 500;
    }
  }
`;

const SpanSubTitleMenuItem = styled.span`
  padding: 5px 0px;
  display: block;
`;

export const MenuLateral = ({ isOpen, onClose, isMobile }) => {
  const sesion = useSelector((state) => state.sesion);
  const empresa = useSelector((state) => state.empresa);
  //const [menuData, setMenuData] = useState([]);
  const [menuState, setMenuState] = useState({});
  const menuData = useSelector((state) => state.accesos);



  // 2. Build a tree structure from the flat data
  const menuTree = useMemo(() => {
    const currentContext = sesion.paciente ? "PACIENTE" : "CONSULTORIO";
    const buildTree = (menus, parentId = null) => {
      if (!menus) return [];
      return menus
        .filter((menu) => {
          const isAtSameLevel = menu.parentId === parentId;
          if (!isAtSameLevel) return false;
          // Si es nivel raíz (parentId === null), validamos el contexto.
          // Si es un sub-nodo, hereda el contexto del padre (no validamos aquí).
          if (parentId === null) {
            return menu.context === currentContext;
          }
          return true;
        })
        .map((menu) => ({ ...menu, children: buildTree(menus, menu.id) }));
    };
    return buildTree(menuData);
  }, [menuData, sesion.paciente]);

  // 3. Initialize state for all collapsible items
  useEffect(() => {
    const initializeState = (items) => {
      const state = {};
      const recurse = (children) => {
        children.forEach(child => {
          if (child.children && child.children.length > 0) {
            state[child.id] = false; // Use ID as key
            recurse(child.children);
          }
        });
      };
      items.forEach(item => {
        if (item.children && item.children.length > 0) {
          state[item.id] = false; // Use ID as key
          recurse(item.children);
        }
      });
      setMenuState(state);
    };
    initializeState(menuTree);
  }, [menuTree]);

  // 4. Recursive function to render the tree
  const renderTree = (items, level = 0, parentUrl = "") => {
    return items?.map((item) => {
      const hasChildren = item.children && item.children.length > 0;
      const isOpen = menuState[item.id];

      const handleToggle = (e) => {
        if (hasChildren) {
          e.preventDefault();
          setMenuState((prev) => {
            const key = item.id;
            const isCurrentlyOpen = prev[key];

            if (level === 0) {
              const newMenuState = { ...prev };
              menuTree.forEach(rootItem => {
                if (rootItem.id !== key) {
                  newMenuState[rootItem.id] = false;
                }
              });
              newMenuState[key] = !isCurrentlyOpen;
              return newMenuState;
            } else {
              return { ...prev, [key]: !isCurrentlyOpen };
            }
          });
        }
      };

      const itemUrl = item.url || "";
      const fullUrl = parentUrl + itemUrl;

      if (level === 0) {
        return (
          <MenuLateralWrapper key={item.id}>
            <DivItemMenu>
              <DivTitle onClick={handleToggle}>
                <SpanTitleMenu>
                  <i className={item.iconFile}></i>
                  {item.nombre}
                </SpanTitleMenu>
              </DivTitle>
              {hasChildren && (
                <DivSubItem className={isOpen ? "sub-item-menu-visible" : "sub-item-menu-hidden"}>
                  {renderTree(item.children, level + 1, fullUrl)}
                </DivSubItem>
              )}
            </DivItemMenu>
          </MenuLateralWrapper>
        );
      }

      return (
        <DivSubTitleMenu key={item.id}>
          <DivSubtitlte>
            <NavLink className="subtitle-menu" to={fullUrl} onClick={handleToggle}>
              <SpanSubTitleMenu>
                <i className={item.iconFile}></i>
                {item.nombre}
              </SpanSubTitleMenu>
            </NavLink>
          </DivSubtitlte>
          {hasChildren && isOpen && (
            <DivSubTitleMenuItem>
              {renderTree(item.children, level + 1, fullUrl)}
            </DivSubTitleMenuItem>
          )}
        </DivSubTitleMenu>
      );
    });
  };

  return (
    <>
      {isMobile && isOpen && <Backdrop onClick={onClose} />}
      <Navbar className={isOpen ? 'is-open' : ''} isMobile={isMobile} isOpen={isOpen}>
        {empresa?.logoUrl ? (
          <img src={empresa.logoUrl} alt="clinic logo" style={{ width: "248px", objectFit: "cover", padding: "10px" }} />
        ) : (
          <div style={{ width: "250px", display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "10px" }}>
            <img src={tu_logo_aqui} alt="tu_logo_aqui"></img>
          </div>
        )}
        {sesion.paciente && (
          <MenuLateralWrapper>
            <DivItemMenu>
              <DivTitle>
                <NavLink to="/paciente/atencion" style={{ textDecoration: 'none', color: 'inherit', width: '100%' }}>
                  <SpanTitleMenu style={{ color: '#0C234C', fontWeight: 'bold' }}>
                    <i className="fas fa-user-md" style={{ color: '#67D2DC' }}></i>
                    Atención Clínica
                  </SpanTitleMenu>
                </NavLink>
              </DivTitle>
            </DivItemMenu>
          </MenuLateralWrapper>
        )}
        {renderTree(menuTree.filter(item => item.type === 'MAIN'))}
      </Navbar>
    </>
  );
};